import { v4 as uuid } from "uuid";

import { FertilizerApplication, FertilizerType } from "models";

export const BLANK_FERTILIZER_APPLICATION = (fertilizerType: FertilizerType) =>
  ({
    id: uuid(),
    endDate: "",
    cropId: "",
    type: `${fertilizerType}Fertilizers`,
    assignedPracticeId: "",
    applicationType: "",
    amount: 0.01,
    // Unit picker must be selected by user - no default for new fertilizers
    amountUnit: null,
    nValue: 0,
    selfProduced: null,
    payout: 0,
  }) as FertilizerApplication;
